// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Input, Button, Label, Toastr } from "@revvsales/components";

// Actions Imports
import { updateDocDetails } from "../../../../actions/DocumentActions";

// Internal Imports
import { DOCUMENTS } from "../../../../constants";

// Destructuring
const { DOCUMENT_TOASTR_MESSAGE } = DOCUMENTS;

class DocRename extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documentName: props.documentName,
      errMsg: "",
      showBtnLoader: false,
    };
  }

  // componentDidMount() {
  //   this.documentNameInput.focus();
  // }

  _onInputChange = event => {
    this.setState({
      documentName: event.target.value,
      errMsg: "",
    });
  };

  _toggleBtnLoader = () => {
    this.setState(prevState => ({ showBtnLoader: !prevState.showBtnLoader }));
  };

  _onSubmit = () => {
    if (this.state.documentName !== this.props.documentName) {
      const payload = {
        data: [
          {
            op: "replace",
            field: "title",
            value: {
              title: this.state.documentName,
            },
          },
        ],
        docId: this.props.documentID,
      };
      this._toggleBtnLoader();
      this.props
        .updateDocDetails(payload)
        .then(res => {
          document.title = `Document | ${res.title}`;
          Toastr.showToastr({
            type: "success",
            message: DOCUMENT_TOASTR_MESSAGE.DOCUMENT_RENAME,
            timeout: 3000,
          });
          this._onClose({ triggerNxt: true });
        })
        .catch(err => {
          console.error(`DocRename => _onSubmit => Error: ${err}`);
        });
    } else {
      this._onClose({ triggerNxt: true });
    }
  };

  _onClose = value => {
    this.props.onClose(value);
  };

  render() {
    const { documentName, errMsg, showBtnLoader } = this.state;

    return (
      <Modal open onClose={this._onClose} center closeOnOverlayClick={false}>
        <div className="docrename-container" data-test="docrename-container">
          <div className="docrename-title" data-test="docrename-title">
            Name the document before sharing
          </div>
          <div className="docrename-form">
            <Label htmlFor="user-email" data-test="docrename-input-label">
              Rename document
            </Label>
            <Input
              autoFocus
              className="docrename-input-field"
              data-test="docrename-input-field"
              type="text"
              name="document-name"
              value={documentName}
              onChange={this._onInputChange}
              placeholder="Enter a document name."
              // ref={name => {
              //   this.documentNameInput = name;
              // }}
            />
            <div className="docrename-err-msg">{errMsg}</div>
          </div>
        </div>
        <div className="docrename-footer">
          <Button
            data-test="docrename-docrename-proceed-button"
            onClick={this._onSubmit}
            isLoading={showBtnLoader}>
            Next
          </Button>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  updateDocDetails,
};

export default connect(
  null,
  mapDispatchToProps,
)(DocRename);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV3/Popups/DocRename/index.js